import {
    LoginViewModel,
    ComponentManager,
    ImageViewModelBuilder
} from 'radpresentation.htmlclient.defaultviewextensions';

export class ONVLoginViewModel extends LoginViewModel
{
    constructor(params: any) {
        super(params);

        this.customerLogo = new ImageViewModelBuilder().withSource('ovsv_full-text.svg')
                                                       .withWidth(900)
                                                       .withAlternativeTextErgName('ARIA_LOGIN_CUSTOMER_LOGO_DESC')
                                                       .build();
        
    }
}

ComponentManager.setViewModel('LoginViewModel', ONVLoginViewModel, 'ONVHTMLViewExtension');
